import React, { memo, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import isObjectEmpty from '../../../../aem-core-components/utils/isObjectEmpty';
import { useDidMount } from '../../../../hooks/useDidMount';
import { FACET_TYPES } from '../../../search/hooks/useSearchUtils';
import Button from '../../atoms/button/button';
import SelectedFilterLabel from './SelectedFilterLabel';

function SelectedFilter({ filterData, setFilterData, facetControllerList, categoryFacet, queryState }) {
    const intl = useIntl();
    const [catFacetState, setCatFacetState] = useState(categoryFacet?.state);
    useEffect(() => {
        !isObjectEmpty(categoryFacet) && categoryFacet?.subscribe(updateState);
    }, []);
    const didMount = useDidMount();
    useEffect(() => {
        if (didMount) {
            clearAll();
        }
    }, [queryState?.query]);

    const updateState = () => {
        setCatFacetState(categoryFacet?.state);
    };

    const toggleCatSelect = value => {
        categoryFacet.toggleSelect(value);
    };
    const displayLabel = () => {
        let labels = [];
        Object.keys(filterData)?.forEach((item, index) => {
            filterData[item]?.selectedOptions?.forEach(label =>
                labels.push(
                    <SelectedFilterLabel key={label} labelText={label} onClose={() => removeLabel(item, label, filterData[item]?.type)} />
                )
            );
        });
        if (catFacetState) {
            labels = [...labels, ...getParents()];
        }
        return labels;
    };
    const getParents = () => {
        const parents = catFacetState?.parents;
        return parents?.map((parent, i) => {
            return (
                <SelectedFilterLabel
                    key={parent.value}
                    labelText={parent.value}
                    onClose={() => {
                        if (i === 0) {
                            categoryFacet.deselectAll();
                        } else {
                            toggleCatSelect(parents[i - 1]);
                        }
                        scrollTo(0, 0);
                    }}
                />
            );
        });
    };
    const labels = displayLabel();
    const clearAll = () => {
        let resetFilterDta = {};
        facetControllerList.forEach(controller => {
            resetFilterDta[controller.state.facetId] = {
                selectedOptions: [],
                facetId: controller.state.facetId,
                type: filterData[controller.state.facetId]?.type
            };
            if (controller?.state?.hasActiveValues) {
                controller.deselectAll();
            }
        });
        !isObjectEmpty(categoryFacet) && categoryFacet.deselectAll();
        setFilterData(resetFilterDta);
        scrollTo(0, 0);
    };
    const removeLabel = (filterName, label, type) => {
        toggleSelect(filterName, label, type);
        const currntFilters = filterData[filterName];
        const isChecked = currntFilters?.selectedOptions?.includes(label);
        var localFilterData = { ...filterData };
        if (isChecked) {
            localFilterData[filterName].selectedOptions = localFilterData[filterName].selectedOptions.filter(
                item => item !== label
            );
        }
        setFilterData(localFilterData);
        scrollTo(0, 0);
    };
    const toggleSelect = (filterName, label, type) => {
        const controller = facetControllerList.find(controller => controller.state.facetId === filterName);
        if (type === FACET_TYPES.NUMERIC_RANGE) {
            const selFilter = controller.state.values.find(item => label.includes(item.start) && label.includes(item.end));
            controller.toggleSelect(selFilter);
        } else {
            const selFilter = controller.state.values.find(item => item.value === label);
            controller.toggleSelect(selFilter);
        }

    };
    return (
        <>
            {labels?.length >= 0 && (
                <div className={`filter__body-badges ${labels?.length > 1 ? 'filter__body-badgesmore' : ''}`}>
                    {labels}
                </div>
            )}
            {/* {catFacetState && getParents()} */}
            {(labels?.length > 0 || (!isObjectEmpty(categoryFacet) && getParents().length > 1)) && (
                <div className="filter__body-topclear">
                    <Button
                        type="button"
                        className={'filter__body-topbutton'}
                        onClick={clearAll}
                        customButtonAriaLabel={intl.formatMessage({ id: 'filter:clear-all-btn-text' })}>
                        {intl.formatMessage({ id: 'filter:clear-all-btn-text' })}
                    </Button>
                </div>
            )}
        </>
    );
}

export default memo(SelectedFilter);

SelectedFilter.defaultProps = {
    categoryFacet: {},
    queryState: {}
};
